import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { initializeIcons } from '@uifabric/icons';
import { createTheme, loadTheme } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import Apps from './Apps';
import { setupInterceptors } from './components/Api';
import ForgotNewPw from './components/Auth/ForgotNewPw/ForgotNewPw';
import ForgotPW from './components/Auth/ForgotPW/ForgotPW';
import Login from './components/Auth/Login/Login';
import SecuredRoute from './components/SecuredRoute/SecuredRoute';
import './i18n';
import './index.css';
import './ktx.css';
import CreateStore from './redux/Store/Store';
import registerServiceWorker from './registerServiceWorker';

initializeIcons();
library.add(fab, fas, far);

const { persistor, store } = CreateStore();

if (window.location.search === '?debug') {
  persistor.purge();
}

setupInterceptors(store);

const mainTheme = createTheme({
  palette: {
    themePrimary: '#f68932',
    themeLighterAlt: '#fffaf6',
    themeLighter: '#fdecdd',
    themeLight: '#fcdbbf',
    themeTertiary: '#f9b781',
    themeSecondary: '#f69749',
    themeDarkAlt: '#dc7b2c',
    themeDark: '#ba6825',
    themeDarker: '#894d1b',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#c2c2c2',
    neutralSecondary: '#858585',
    neutralPrimaryAlt: '#4b4b4b',
    neutralPrimary: '#333333',
    neutralDark: '#272727',
    black: '#1d1d1d',
    white: '#ffffff'
  }
});

loadTheme(mainTheme);

// TODO: Decide how to receive the user/pass from OLD KTX
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={process.env.REACT_APP_ALIAS}>
        <Switch>
          <Route exact={true} path="/login" component={Login} />
          <Route exact={true} path="/forgot" component={ForgotPW} />
          <Route exact={true} path="/forgot/:guid" component={ForgotNewPw} />
          <SecuredRoute path="/" component={Apps} />
        </Switch>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();
